import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AiAnalysisRequest {
  analysisType: string;
  language: string;
  mail?: string;
  action?: string;
  department?: string;
  priority?: string;
  sensitiveCount?: number;
  externalDelivery?: boolean;
  infoLeak?: boolean;
  dateBegin?: string;
  dateEnd?: string;
  customPrompt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AiService {
  private readonly analyzeUrl = environment.apiUrl + 'Ai/analyze';
  private readonly statusUrl = environment.apiUrl + 'Ai/status';

  checkStatus(): Promise<boolean> {
    const token = localStorage.getItem('token');
    return fetch(this.statusUrl, {
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) }
    })
      .then(r => r.json())
      .then(d => d.aiProEnabled === true)
      .catch(() => false);
  }

  streamAnalysis(request: AiAnalysisRequest): Observable<string> {
    const token = localStorage.getItem('token');

    return new Observable(observer => {
      let cancelled = false;
      const controller = new AbortController();

      fetch(this.analyzeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify(request),
        signal: controller.signal
      })
        .then(response => {
          if (!response.ok) {
            observer.error(`HTTP error ${response.status}`);
            return;
          }
          const reader = response.body.getReader();
          const decoder = new TextDecoder();

          const pump = () => {
            if (cancelled) return;
            reader.read().then(({ done, value }) => {
              if (done || cancelled) {
                observer.complete();
                return;
              }

              const text = decoder.decode(value, { stream: true });
              const lines = text.split('\n');

              for (const line of lines) {
                if (!line.startsWith('data: ')) continue;
                const payload = line.slice(6).trim();
                if (payload === '[DONE]') {
                  observer.complete();
                  return;
                }
                try {
                  const chunk: string = JSON.parse(payload);
                  observer.next(chunk);
                } catch { }
              }

              pump();
            }).catch(err => {
              if (!cancelled) observer.error(err);
            });
          };

          pump();
        })
        .catch(err => {
          if (!cancelled) observer.error(err);
        });

      return () => {
        cancelled = true;
        controller.abort();
      };
    });
  }
}
